import $ from "jquery";

const tabsClass = ".js--tabs";
const tabClass = ".js--tab";
const $tabsTrigger = $(".js--tabs-trigger");
const activeClass = "is--active";

$tabsTrigger.on("click", function () {
  var $t = $(this);
  var tabIndex = $t.index();
  var $tab = $t
    .parents(tabsClass)
    .first()
    .find(tabClass + ":eq(" + tabIndex + ")");

  $t.toggleClass(activeClass).siblings().removeClass(activeClass);
  $tab.toggleClass(activeClass).siblings().removeClass(activeClass);
});
